import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

//Primereact components
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { Badge } from 'primereact/badge';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';

// Column
import { DuplicateCertificateColumns } from '../../../appconfig/DatatableSetting';

// Data table
import { defaultRowOptions, defaultPageRowOptions, Skeletonitems, SkeletonbodyTemplate, paginatorLinks, showingEntries, DataStatusOptions, DUPLICATECERTYNAME } from '../../../appconfig/Settings';

//Services
import { deleteDataWithMultipleParameters, getAllDetails } from '../../../service/ProductService';

import { DELETE_REFUND, OTHER_APPLIST } from '../../../config/ApiConstant';
import { checkEmail, formatDateTime, setOtherAppStatus } from '../../../appconfig/AppHelper';
import moment from 'moment';
import { ApplicationTab } from '../applicationTab';
import { OtherApplicationTab } from './OtherApplicationTab';
import { createdAtTemplate, othApplicationsFullNameTemplate, verifiedByTemplate } from '../../../appconfig/DatatableTemplateSetting';
import { Avatar } from 'primereact/avatar';
import { NavLink } from 'react-router-dom';
import CustomDatePicker from '../../../components/CustomDatePicker/CustomDatePicker';

export const DuplicateCertificate = () => {
    document.title = 'Duplicate Certificate Application | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);
    const [searchVal, setSearchVal] = useState<any>(null);

    // Date Object
    const storedDates = localStorage.getItem('duplicate_certy_app');
    let initialStartDate = moment().subtract(30, 'days').toDate();
    let initialEndDate = moment().toDate();

    if (storedDates) {
        try {
            const parsed = JSON.parse(storedDates);
            initialStartDate = parsed.startDate ? new Date(parsed.startDate) : initialStartDate;
            initialEndDate = parsed.endDate ? new Date(parsed.endDate) : initialEndDate;
        } catch (error) {
            console.error('Error parsing stored dates', error);
        }
    }

    const [dates, setDates] = useState({
        start: initialStartDate,
        end: initialEndDate
    });

    // Navigate
    const navigate = useNavigate();

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(false);
    const [applicationsList, setApplicationsList] = useState<any>([]);
    const [deleteModal, setDeleteModal] = useState<boolean>(false);
    const [deleteId, setDeleteId] = useState<any>(null);
    const [deleteBillSrNo, setDeleteBillSrNo] = useState<any>(null);
    const [deleteLoader, setDeleteLoader] = useState<boolean>(false);
    const [appStatusFilter, setAppStatusFilter] = useState<any>({ name: 'All', code: 'All' });
    const [isEmail, setIsEmail] = useState<boolean>(false);

    // useEffect
    useEffect(() => {
        getAllDuplicateCertificateApplication();

        const mail = checkEmail(localStorage.getItem('email'));
        if (mail) {
            setIsEmail(true);
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [dates]);

    // Get all duplicate certificate applications
    const getAllDuplicateCertificateApplication = async () => {
        try {
            setPageLoad(false);
            let startDate = moment(dates?.start).format('y-M-D') + ' 00:00:00';
            let endDate = moment(dates?.end).format('y-M-D') + ' 23:59:59';
            const response = await getAllDetails(OTHER_APPLIST + '?AppNm=' + DUPLICATECERTYNAME + '&start_date=' + startDate + '&end_date=' + endDate + '&search=' + searchVal);
            if (response) {
                const DataList: any = response;

                if (DataList.length === 0) {
                    setApplicationsList([]);
                } else {
                    setApplicationsList(DataList);
                }
                setPageLoad(true);
            } else {
                setPageLoad(false);
                setApplicationsList([]);
            }
        } catch (error: any) {
            setPageLoad(false);
            setApplicationsList([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <span className="block mt-2 md:mt-0 p-input-icon-left mr-3">
                    <i className="pi pi-search"></i>
                    <InputText value={searchVal} onChange={(e) => setSearchVal(e.target.value)} placeholder="Search..." className="" />
                    <i className="pi pi-times input-s" onClick={() => removeSearch()} style={{ right: '10px', zIndex: '111111', cursor: 'pointer' }}></i>
                </span>

                <Button label="" icon="pi pi-search" className="p-button p-button-rounded" onClick={() => getAllDuplicateCertificateApplication()} />
            </>
        );
    };

    // On Date Change
    const onDateChange = (start: any, end: any) => {
        setDates({ start, end });

        if (start && end) {
            localStorage.setItem(
                'duplicate_certy_app',
                JSON.stringify({
                    startDate: moment(start).format('YYYY-MM-DD'),
                    endDate: moment(end).format('YYYY-MM-DD')
                })
            );
        }
    };

    //remove serach
    const removeSearch = () => {
        setSearchVal(null);
        setGlobalFilter(null);
        getAllDuplicateCertificateApplication();
    };

    //Clear All Filter
    const clearAll = () => {
        setGlobalFieldFilter(null);
        setGlobalFilter(null);
    };

    // Right toolbar
    const rightToolbarTemplate = () => {
        return (
            <>
                <CustomDatePicker startDate={dates?.start} endDate={dates?.end} onChange={onDateChange} />

                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAll()} className="p-button-outlined ml-2"></Button>
            </>
        );
    };

    // Search by app status
    const searchByAppStatus = (options: any) => {
        return (
            <Dropdown
                filter
                value={appStatusFilter}
                onChange={(e: any) => {
                    setAppStatusFilter(e.value);
                    options.filterCallback(e.value.code, options.index);
                }}
                options={DataStatusOptions}
                optionLabel="name"
                placeholder="Search By Status"
                className="order-drp"
            ></Dropdown>
        );
    };

    // Open delete with refund modal
    const openDeleteWithRefundModal = (id: any, billSrNo: any) => {
        setDeleteId(id);
        setDeleteBillSrNo(billSrNo);
        setDeleteModal(true);
    };

    // Close delete with refund modal
    const closeDeleteWithRefundModal = () => {
        setDeleteId(null);
        setDeleteBillSrNo(null);
        setDeleteLoader(false);
        setDeleteModal(false);
    };

    // Template for actions
    const actionsTemplate = (rowData: any) => {
        return (
            <>
                <div className="actions action-btn">
                    <Button
                        tooltip="View"
                        tooltipOptions={{ position: 'top' }}
                        icon="pi pi-eye"
                        onClick={() => navigate('/app/application/viewOtherAppDocument/' + btoa(rowData.EntryNo) + '/' + btoa(DUPLICATECERTYNAME) + '/' + btoa(rowData.RNo) + '/' + btoa(rowData.AppAccept))}
                    />
                    {isEmail === true && <Button icon="pi pi-trash" tooltip="Delete With Refund" tooltipOptions={{ position: 'top' }} className="p-button-danger ml-2" onClick={() => openDeleteWithRefundModal(rowData.RNo, rowData?.billSrNo)} />}
                </div>
            </>
        );
    };

    // Template for validity date
    const LastVDateTemplate = (rowData: any) => {
        return (
            <>
                <div>{!window.cn(rowData?.applicant_details.LastVDate) ? formatDateTime(rowData?.applicant_details.LastVDate) : '-'}</div>
            </>
        );
    };

    // Template for comment
    const commentTemplate = (rowData: any) => {
        let appStatusVal = setOtherAppStatus(rowData.AppAccept);
        return (
            <>
                {appStatusVal.value === 'Rejected' || appStatusVal.value === 'Hold' ? (
                    <Button tooltip={rowData?.comment} className="p-button-custom-tooltip" tooltipOptions={{ position: 'top' }}>
                        <div className="college-name-div">{rowData?.comment}</div>
                    </Button>
                ) : (
                    '-'
                )}
            </>
        );
    };

    //nameTemplate
    const fullNameTemplate = (rowData: any) => {
        return (
            <>
                <NavLink to={`/app/application/viewOtherAppDocument/${btoa(rowData.EntryNo)}/${btoa(DUPLICATECERTYNAME)}/${btoa(rowData.RNo)}/${btoa(rowData.AppAccept)}`}>
                    <div className="avatar-div flex align-items-center">
                        {!window.cn(rowData?.applicant_details.Image) ? <Avatar image={rowData?.applicant_details.Image} shape="circle" /> : <Avatar icon="pi pi-user" shape="circle" />}
                        <div className="emp-name link-name ml-2">{rowData?.StudNm}</div>
                    </div>
                </NavLink>
            </>
        );
    };

    // Template for status
    const statusTemplate = (rowData: any) => {
        let appStatusVal = setOtherAppStatus(rowData.AppAccept);
        return (
            <>
                <Badge severity={appStatusVal.severity} value={appStatusVal.value}></Badge>
            </>
        );
    };

    // Delete with refund api call
    const deleteWithRefundApiCall = async () => {
        try {
            setDeleteLoader(true);
            // Delete api call
            const response = await deleteDataWithMultipleParameters(DELETE_REFUND + '?sr_no=' + deleteId + '&app_name=' + DUPLICATECERTYNAME + '&transaction_id=' + deleteBillSrNo);
            if (response) {
                toast.current?.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: response?.message
                });
                setDeleteLoader(false);
                setDeleteModal(false);
                setDeleteId(null);
                setDeleteBillSrNo(null);
                getAllDuplicateCertificateApplication();
            } else {
                setPageLoad(false);
                toast.current?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Something went wrong, Please try again.'
                });
                setDeleteLoader(false);
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setDeleteLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    return (
        <>
            <ApplicationTab mainTabLabel="Other Application" />
            <OtherApplicationTab initialTabLabel="Duplicate Cert." />
            <Toast ref={toast} />
            <div className="grid crud-demo">
                <div className="col-12">
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>

                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={applicationsList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    rows={defaultRowOptions}
                                    paginator={applicationsList.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    className="datatable-responsive p-datatable-sm"
                                    emptyMessage="No Applications Found"
                                    paginatorTemplate={paginatorLinks}
                                    currentPageReportTemplate={showingEntries}
                                >
                                    {DuplicateCertificateColumns.map((col, i) => {
                                        if (col.field === 'action') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={actionsTemplate} />;
                                        } else if (col.field === 'AppAccept') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={statusTemplate} filter filterElement={searchByAppStatus} />;
                                        } else if (col.field === 'LastVDate') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={LastVDateTemplate} style={{ minWidth: '8rem' }} />;
                                        } else if (col.field === 'comment') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={commentTemplate}  style={{maxWidth : "13rem"}} />;
                                        } else if (col.field === 'StudNm') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={fullNameTemplate} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        } else if (col.field === 'verified_by') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={verifiedByTemplate} style={{ minWidth: '7rem' }} />;
                                        } else if (col.field === 'created_at') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={createdAtTemplate} style={{ minWidth: '8rem' }} />;
                                        } else if (col.field === 'RegNo') {
                                            return <Column key={col.field} field={col.field} header={col.header} filter filterPlaceholder={'Search by ' + col.header} style={{ minWidth: '8rem' }} />;
                                        } else if (col.field === 'EntryNo') {
                                            return <Column key={col.field} field={col.field} header={col.header} filter filterPlaceholder={'Search by ' + col.header} style={{ minWidth: '8rem' }} />;
                                        } else if (col.field === 'billSrNo') {
                                            return <Column key={col.field} field={col.field} header={col.header} filter filterPlaceholder={'Search by ' + col.header} style={{ minWidth: '12rem' }} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                                {/* <Paginator first={first} rows={perPage} totalRecords={totalRecords} rowsPerPageOptions={defaultPageRowOptions} onPageChange={onPageChange} /> */}
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {DuplicateCertificateColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {/* Delete With Refund Dialog */}
            <Dialog
                visible={deleteModal}
                style={{ width: '550px' }}
                header="Delete Application"
                modal
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={closeDeleteWithRefundModal} />
                        <Button label="Delete With Refund" icon="pi pi-trash" className="p-button-danger" onClick={deleteWithRefundApiCall} loading={deleteLoader} />
                    </>
                }
                onHide={closeDeleteWithRefundModal}
            >
                <div className="flex align-items-center justify-content-start">
                    <i className="pi pi-exclamation-triangle mr-3 delete-triangle" style={{ fontSize: '2rem' }} />
                    <span className="delete-dialog-note">Note: Once you delete this Application, This will be deleted permanently.</span>
                </div>
            </Dialog>
        </>
    );
};
